import React, { useEffect, useState } from "react";
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import PageHeader from "../components/PagesHeaderComponent/PageHeader";
import PageHeaderWithRoutes from "../components/PagesHeaderComponent/PageHeaderWithRoute";
import ELearningIcon from "../../assets/images/icons/e_learning_icon.png"
import WebinarIcon from "../../assets/images/icons/webinar_icon.png"
import PresentationIcon from "../../assets/images/icons/presentation.png"
import PodcastIcon from "../../assets/images/icons/podcaster.png"
import ReportIcon from "../../assets/images/icons/report.png"
import { Col, Container, Modal, Row, Form } from "react-bootstrap";
import InnerHeading from "../components/InnerHeading/InnerHeading";
import { Button as AntButton, Dropdown, Input, Menu, Pagination } from "antd";
import { useNavigate } from "react-router-dom";
import CoreHttpHandler from "../../http/services/CoreHttpHandler";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { ToastAlertError, ToastAlertSuccess } from "../../reauseble";
import { Box, LinearProgress } from "@mui/material";
import RegisterModal from "../components/RegisterModalComponent/RegisterModal";
import CustomTextLimit from "../../assets/global-components/TextLimit";

const Learning = () => {
    const navigate = useNavigate();

    const [data, setData] = useState([]);
    const [allData, setAllData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [modalShow, setModalShow] = useState(false);
    const [searchTitle, setSearchTitle] = useState("");
    const [selectedOrder, setSelectedOrder] = useState("DESC");
    const pageSize = 6;

    const getCourses = () => {
        setIsLoading(true)
        CoreHttpHandler.request(
            "shareholder_education",
            "fetchCourses",
            {
                "status": true,
                "limit": 10000,
                "page": 1
            },
            (res) => {
                setAllData(res.data.data.courses.courses)
                setIsLoading(false)
            },
            (err) => {
                setIsLoading(false)
            }
        );
    };

    const filterCourses = () => {
        let filtered = allData;

        if (searchTitle) {
            filtered = filtered.filter(course =>
                course.module?.toLowerCase().includes(searchTitle.toLowerCase())
            );
        }

        const sorted = [...filtered].sort((a, b) =>
            selectedOrder === "ASC"
                ? a.id - b.id
                : b.id - a.id
        );

        setData(sorted);
        setCurrentPage(1);
    };

    const handleOrderMenuClick = (e) => {
        setSelectedOrder(e.key);
    };

    const clearSearch = () => {
        setSearchTitle("");
        setSelectedOrder("DESC");
        setData(allData);
        setCurrentPage(1);
    };

    const orderMenu = (
        <Menu onClick={handleOrderMenuClick}>
            <Menu.Item key={"ASC"}>ASC</Menu.Item>
            <Menu.Item key={"DESC"}>DESC</Menu.Item>
        </Menu>
    );

    const paginatedData = data.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
    );

    useEffect(() => {
        getCourses();
    }, [])

    useEffect(() => {
        filterCourses();
    }, [allData])

    const handleBtnClick = (data) => {
        if (data.is_paid) {
            let userToken = localStorage.getItem("token");

            if (userToken) {
                navigate(`/myCourses/${data.module}`, {
                    state: {
                        ...data,
                    },
                });
            } else {
                setModalShow(true)
            }

        } else {

            navigate(`/myCourses/${data.module}`, {
                state: {
                    ...data,
                },
            });

        }

        // if(userToken) {
        //     navigate(`/myCourses/${data.module}`, {
        //         state: {
        //             ...data,
        //         },
        //     });
        // } else {
        //     setModalShow(true)
        // }

    }

    let headerData = [{
        name: "E - Learning",
        route: "/ShareHolderEducation/learning",
        imgSrc: ELearningIcon
    }, {
        name: "Webinars & Events",
        route: "/ShareHolderEducation/WebinarsandEvents",
        imgSrc: WebinarIcon
    }, {
        name: "Presentation",
        route: "/ShareHolderEducation/Presentation",
        imgSrc: PresentationIcon
    }, {
        name: "PICG\nPodcast",
        route: "/ShareHolderEducation/PICGPodcast",
        imgSrc: PodcastIcon
    }, {
        name: "Governance\nUpdate",
        route: "/ShareHolderEducation/GovernanceUpdate",
        imgSrc: ReportIcon
    }
    ]

    return (
        <>
            {/* <PageHeader heading="Learning Center" /> */}
            <PageHeaderWithRoutes tabs={headerData} heading="Shareholder Education" desc="Explore our e-learning platform to discover diverse courses, access your student dashboard, and manage your enrollments. Register for upcoming webinars or catch up on past sessions with our archived videos to keep your learning journey on track." />


            <div className="content_wrap">

                <section className='sec sec8'>
                    <div className='container'>
                        <div className="cards_wrap">
                            <Container>
                                <Row>
                                    <Col xs={12} style={{ animation: "fadeInUp 0.5s ease both" }}>
                                        <Row className="d-flex align-items-center justify-content-center mb-4">
                                            <Col lg={5} md={5} xs={12} style={{ marginBottom: "10px" }}>
                                                <Input
                                                    value={searchTitle}
                                                    style={{
                                                        width: "100%",
                                                        borderRadius: "20px",
                                                        padding: "8px 15px",
                                                        transition: "all 0.3s ease",
                                                        border: "1px solid #d9d9d9"
                                                    }}
                                                    onFocus={(e) => e.target.style.boxShadow = "0 0 0 3px rgba(7,88,143,0.1)"}
                                                    onBlur={(e) => e.target.style.boxShadow = "none"}
                                                    onChange={(e) => setSearchTitle(e.target.value)}
                                                    placeholder="Search by Course Name"
                                                />
                                            </Col>
                                            <Col lg={2} md={2} xs={4} style={{ marginBottom: "10px" }}>
                                                <Dropdown overlay={orderMenu} trigger={['click']}>
                                                    <AntButton
                                                        style={{
                                                            width: "100%",
                                                            borderRadius: "20px",
                                                            padding: "0 15px",
                                                            height: "36px",
                                                            transition: "all 0.3s ease"
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.currentTarget.style.borderColor = "#07588f";
                                                            e.currentTarget.style.color = "#07588f";
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.currentTarget.style.borderColor = "#d9d9d9";
                                                            e.currentTarget.style.color = "rgba(0,0,0,0.85)";
                                                        }}
                                                    >
                                                        Sort: {selectedOrder} ▼
                                                    </AntButton>
                                                </Dropdown>
                                            </Col>
                                            <Col lg={3} md={3} xs={8} style={{ marginBottom: "10px", display: "flex", gap: "8px" }}>
                                                <AntButton
                                                    style={{
                                                        background: "#07588f",
                                                        color: "#fff",
                                                        border: "none",
                                                        flex: 1,
                                                        borderRadius: "20px",
                                                        height: "36px",
                                                        transition: "all 0.3s ease"
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.background = "#0a6ebd";
                                                        e.currentTarget.style.transform = "translateY(-2px)";
                                                        e.currentTarget.style.boxShadow = "0 4px 12px rgba(7,88,143,0.3)";
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.background = "#07588f";
                                                        e.currentTarget.style.transform = "translateY(0)";
                                                        e.currentTarget.style.boxShadow = "none";
                                                    }}
                                                    onClick={() => filterCourses()}
                                                >
                                                    Search
                                                </AntButton>
                                                <AntButton
                                                    style={{
                                                        flex: 1,
                                                        borderRadius: "20px",
                                                        height: "36px",
                                                        transition: "all 0.3s ease"
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.borderColor = "#07588f";
                                                        e.currentTarget.style.color = "#07588f";
                                                        e.currentTarget.style.transform = "translateY(-2px)";
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.borderColor = "#d9d9d9";
                                                        e.currentTarget.style.color = "rgba(0,0,0,0.85)";
                                                        e.currentTarget.style.transform = "translateY(0)";
                                                    }}
                                                    onClick={clearSearch}
                                                >
                                                    Clear
                                                </AntButton>
                                            </Col>
                                        </Row>
                                    </Col>

                                    {isLoading ?
                                        <Box sx={{ my: '5rem' }}>
                                            <LinearProgress color="success" />
                                        </Box>
                                        :
                                        paginatedData.map((e, index) => {
                                            return <>
                                                <Col xl={4} lg={6} md={6} xs={12} style={{ marginBottom: "20px" }}>
                                                    <Card
                                                        className="cards"
                                                        style={{
                                                            transition: "transform 0.3s ease, box-shadow 0.3s ease",
                                                            animation: `fadeInUp 0.5s ease ${index * 0.1}s both`
                                                        }}
                                                        onMouseEnter={(ev) => {
                                                            ev.currentTarget.style.transform = "translateY(-5px)";
                                                            ev.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.12)";
                                                        }}
                                                        onMouseLeave={(ev) => {
                                                            ev.currentTarget.style.transform = "translateY(0)";
                                                            ev.currentTarget.style.boxShadow = "";
                                                        }}
                                                    >
                                                        <CustomTextLimit limit={50} title text={e.module} />
                                                        <CustomTextLimit text={e.short_description} />
                                                        <img
                                                            src={e.thumbnail}
                                                            height="200px"
                                                            loading="lazy"
                                                            width="100%"
                                                            style={{
                                                                objectFit: "cover",
                                                                transition: "transform 0.3s ease"
                                                            }}
                                                            onMouseEnter={(ev) => ev.currentTarget.style.transform = "scale(1.03)"}
                                                            onMouseLeave={(ev) => ev.currentTarget.style.transform = "scale(1)"}
                                                        />

                                                        <div className="card-content">
                                                            <div>
                                                                <h6 className="bold">Date:</h6>
                                                                <h6>{moment(e?.dt).format("DD-MM-YYYY")}</h6>
                                                            </div>
                                                            <Button size="sm" onClick={() => handleBtnClick(e)} className="card_btn" variant="primary">View Course</Button>
                                                        </div>
                                                    </Card>
                                                </Col>
                                            </>
                                        })}
                                </Row>
                            </Container>
                            <Pagination
                                total={data.length}
                                current={currentPage}
                                pageSize={pageSize}
                                hideOnSinglePage
                                onChange={(page) => setCurrentPage(page)} />
                        </div>
                    </div>
                </section>

                <RegisterModal
                    modalShow={modalShow}
                    setModalShow={setModalShow}
                />

                {/* <Modal backdrop="static"
                    centered
                    dialogClassName="modal-90w"
                    keyboard={false}
                    show={modalShow}
                    // onHide={() => setModalShow(false)}
                    aria-labelledby="contained-modal-title-vcenter">
                    <FontAwesomeIcon onClick={() => setModalShow(false)} fontSize={30} className="close_modal_icon" icon={faXmark} />
                    <Modal.Header className="register_modal-bg modal_head_center" >
                        <Modal.Title id="contained-modal-title-vcenter">
                            Register Now
                        </Modal.Title>
                    </Modal.Header>
                </Modal> */}

            </div>



            {/* <div className="content_wrap"> */}

            {/* <div className="learning_wrap">
                    <div className='container learning'>
                        <Container>
                            <Row>
                            <InnerHeading heading="E - Learning" text="Sign up now to explore our interactive online awareness courses especially curated to educate shareholders on various aspects of corporate governance." />

                                {data.map((e) => {
                                    return <>
                                        <Col lg={4} md={6} >
                                            <Card className="cards">
                                                <h5>{e.title}</h5>
                                                <p>{e.desc}</p>
                                                <div className="card-content flex_btw">
                                                    <h6><span className="bold">Class No. </span><br />{e.date}</h6>
                                                    <button className="rounded_btn">Enroll</button>
                                                </div>
                                            </Card>
                                        </Col>
                                    </>
                                })}
                            </Row>
                        </Container>
                    </div>
                </div> */}
            {/* </div> */}
        </>
    );
};

export default Learning;
